import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, PopoverController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import * as moment from 'moment';
import { AlerttypesPage } from './alerttypes/alerttypes';
import { PopupPage } from '../../popup/popup';

/**
* Generated class for the AlertsaddPage page.
*
* See https://ionicframework.com/docs/components/#navigation for more info on
* Ionic pages and navigation.
*/

@Component({
  selector: 'page-alertsadd',
  templateUrl: 'alertsadd.html',
})
export class AlertsaddPage {
  Title = ''
  alertid: number = -1;
  alert: any;
  alertTypes: any = [];
  allAlerts: any = [];

  allowfuel: any = '0'
  allowedrfid: any = '0'
  allowedcapace: any = '0'

  typeChoosen: any = '-1';

  poitype1: any = []; // ova e za toi
  poitype23: any = []; // ova e za zoni (poi)


  toiZadrzhuvanje: any = '-1';
  minZadrzVoTOI: any = '0';

  nadminSpeed: any = ''
  nadminRpm: any = ''
  lowerLimitFuel: any = ''
  maxRoomTemp: any = ''
  minRoomTemp: any = ''

  potsetiRegDenovi: any = '0'
  potsetiRegKm: any = '0'


  poiVlez: any = '-1';
  poiIzlez: any = '-1';

  alertFor: any = '-1';
  oneVehicle: any = '-1';
  orgUnit: any = '-1'

  dostapen: any = '1'
  sound: any = '1';
  toemails: any = ''

  fromVehicle: any
  fromvehicleNew: any
  vehicle: any

  // potsetiServiceSplit: any = ''
  // potsetiServiceSplit1: any = ''
  remindmeKm: any = ''
  remindmeDays: any = ''

  remindSave = ''

  _speedafter: number = -1 //se koristi i za rpm; this.alert.speed isto e za rpm alertot
  _componentNameId: any = '-1';

  // public autoCorrect: boolean = false;
  // public value: number = 5;

  soundPlayer: any
  otstapuvanjeRuta: any = ''

  minBluethootTemp: any = ''
  maxBluethootTemp: any = ''
  maxbluehumidity: any = ''
  minbluehumidity: any = ''

  loadingData = false
  countloading = 0

  typeChoosenName = ''
  components = []

  selectedVehicleName = ''
  selectedVehicleIds = ''

  selectedAZonesIds = []
  selectedAZones = '--- ' + this.dic.l["chooseallowedzones"] + ' ---';
  idxAZones = ''
  _az = ''
  _bleslots = []
  _bval = "-1"

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController, public popoverCtrl: PopoverController) {
    // alert(this.isNormalInteger(900))
    // alert(this.isNormalInteger('bosko'))

    this.alertid = this.navParams.get('alertid');
    // this.alert = this.navParams.get('alert');
    if (this.alertid == -1) {
      this.typeChoosenName = this.dic.l["choosealert"]
      this.Title = this.dic.l["newalert"]
      this.fromvehicleNew = this.navParams.get('fromvehicleNew')
      this.soundPlayer = new Audio('../../../assets/sound/probno.mp3');
      // this.selectedVehicleIds = this.vehicle + ''
      this.selectedVehicleName = '-- ' + this.dic.l["choosevehicle"] + ' --'
      if (this.fromvehicleNew == 1) {
        this.alertFor = 1
        this.vehicle = this.navParams.get('vehicle')
        this.oneVehicle = this.vehicle
        this.selectedVehicleIds = this.vehicle + ''
        for (var i = 0; i < this.gn.Vehicles.length; i++) {
          if (this.vehicle == this.gn.Vehicles[i].vehicleid) {
            this.selectedVehicleName = '(' + this.gn.Vehicles[i].code + ') ' + this.gn.Vehicles[i].registration;
          }
        }

      }
      var _that = this
      _that.gn._Post('/api/gn/getallbleslots', { vid: _that.gn.crypt(_that.oneVehicle) }, function (_data) {
        _that._bleslots = _data
      })
    }
    else {
      this.fromVehicle = this.navParams.get('fromVeh')
      if (this.fromVehicle == 1) {
        this.alert = this.navParams.get('alert');
        this.allAlerts = this.navParams.get('allAlerts')
        this.typeChoosen = this.alert.alarmtypeid
      }
      this.Title = this.dic.l["editalert"]
      //edit na postoechki alert
      this.alert = this.navParams.get('alert');
      this.typeChoosenName = this.dic.l[this.alert.name]


      this.allAlerts = this.navParams.get('allAlerts')
      this.typeChoosen = this.alert.alarmtypeid
      // this.toiZadrzhuvanje = this.alert.toiZadrzhuvanje+''
      this.minZadrzVoTOI = this.alert.toiZadrzhuvanje + '' == '-1' ? '-1' : this.alert.timeofpoi
      this._speedafter = this.alert.speedafter
      this.nadminSpeed = this.alert.speed + ''
      this.nadminSpeed = parseInt(this.nadminSpeed * this.gn.user.metricvalue + '')
      this.nadminRpm = this.alert.speed + ''
      this.lowerLimitFuel = this.alert.settings + ''
      this._az = this.alert.settings + ''
      this.lowerLimitFuel = parseInt(this.lowerLimitFuel * this.gn.user.liquidvalue + '')
      var string = this.alert.remindme + ''
      var substring = this.dic.l["days"];
      // string.includes(substring);
      if (string.includes(substring) == true) {
        var arr = this.alert.remindme.split(' ')
        this.remindmeDays = arr[0]
      }
      if (this.remindmeDays == -1) {
        this.remindmeDays = ''
      }
      if (this.alert.remindme1 == undefined) {
        this.remindmeKm = ''
      }

      if (this.typeChoosen + '' == '18' || this.typeChoosen + '' == '94') {
        var string2 = this.alert.remindme + ''
        var substring2 = 'km';

        if (string2.includes(substring2) == true) {
          var arr5 = this.alert.remindme.split(' ')
          this.remindmeKm = arr5[0]

        }
        else {
          if (this.alert.remindme1 != undefined) {
            this.remindmeKm = this.alert.remindme1
            this.remindmeKm = parseInt((this.remindmeKm * this.gn.user.metricvalue + ''))
            if (this.remindmeKm == -1) {
              this.remindmeKm = ''
            }
          }
        }
      }

      if (this.typeChoosen + '' == '8') {
        this.poiVlez = this.alert.poiid
        this.poiIzlez = -1;
        this.toiZadrzhuvanje = -1;
      }
      if (this.typeChoosen + '' == '9') {
        this.poiIzlez = this.alert.poiid
        this.poiVlez = -1;
        this.toiZadrzhuvanje = -1;
      }
      if (this.typeChoosen + '' == '10') {
        this.toiZadrzhuvanje = this.alert.poiid
        this.poiVlez = -1;
        this.poiIzlez = -1;
      }
      if (this.typeChoosen + '' == '69') {
        this.minRoomTemp = this.alert.settings
      }
      if (this.typeChoosen + '' == '70') {
        this.maxRoomTemp = this.alert.settings
      }

      if (this.typeChoosen + '' == '15') {
        this.otstapuvanjeRuta = this.alert.settings
      }

      if (this.typeChoosen + '' == '88') {
        this.minBluethootTemp = this.alert.settings
      }
      if (this.typeChoosen + '' == '106') {
        this.maxBluethootTemp = this.alert.settings
      }

      if (this.typeChoosen + '' == '90') {
        this.maxbluehumidity = this.alert.settings
      }
      if (this.typeChoosen + '' == '91') {
        this.minbluehumidity = this.alert.settings
      }
      if (this.typeChoosen + '' == '94') {
        this._componentNameId = this.alert.settings
      }

      this.alertFor = this.alert.typeofgroup
      this.oneVehicle = this.alert.vehicleid
      this.orgUnit = this.alert.settings
      this.dostapen = this.alert.available
      this.sound = this.alert.soundid
      this.selectedVehicleIds = this.oneVehicle
      if (this.sound == 1) {
        this.soundPlayer = new Audio('../../../assets/sound/probno.mp3');

      }
      if (this.sound == 2) {
        this.soundPlayer = new Audio('../../../assets/sound/probno2.mp3');

      }
      if (this.sound == 3) {
        this.soundPlayer = new Audio('../../../assets/sound/probno3.mp3');
      }
      this.toemails = this.alert.emails
      for (var i = 0; i < this.gn.Vehicles.length; i++) {
        if (this.oneVehicle == this.gn.Vehicles[i].vehicleid) {
          this.selectedVehicleName = '(' + this.gn.Vehicles[i].code + ') ' + this.gn.Vehicles[i].registration;
        }
      }

      var _that = this
      _that.gn._Post('/api/gn/getallbleslots', { vid: _that.gn.crypt(_that.oneVehicle) }, function (_data) {
        _that._bleslots = _data
        _that._bval = _that.alert.bleslotnum
      })

    }
  }

  ionViewDidLoad() {
    this.getSettingsForClientUser();
    // this.emailValidate('boskokocev94@gmail.com')
  }



  soundchanges() {
    this.pauseSound()
    if (this.sound == 1) {
      this.soundPlayer = new Audio('../../../assets/sound/probno.mp3');

    }
    if (this.sound == 2) {
      this.soundPlayer = new Audio('../../../assets/sound/probno2.mp3');

    }
    if (this.sound == 3) {
      this.soundPlayer = new Audio('../../../assets/sound/probno3.mp3');
    }
  }

  playSound() {

    this.soundPlayer.play();
  }
  pauseSound() {
    this.soundPlayer.pause();
    this.soundPlayer.currentTime = 0;
  }
  volumeUp() {
    if (this.soundPlayer.volume < 1) {
      this.soundPlayer.volume += 0.1
    }

  }

  volumeDown() {
    if (this.soundPlayer.volume > 0.1) {
      this.soundPlayer.volume -= 0.1
    }
  }

  convertMetric(edinica, vrednost) {
    return (edinica.toLowerCase() == 'mi') ? (Number(vrednost) * 1.60934) : Number(vrednost);
  }


  saveAlert() {
    //var _that = this
    var poiAdd = '-1'

    if (this.typeChoosen + '' == '-1') {
      let toast = this.toastCtrl.create({ message: this.dic.l["pleasetypeofalert"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.typeChoosen + '' == '8') {
      poiAdd = this.poiVlez;
      if (poiAdd == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["selectgeofenceenter"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }
    if (this.typeChoosen + '' == '9') {
      poiAdd = this.poiIzlez;
      if (poiAdd == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["selectgeofenceexit"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }
    if (this.typeChoosen + '' == '10') {
      poiAdd = this.toiZadrzhuvanje
      if (poiAdd == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterpoiname"], duration: 3000, position: 'top' });
        toast.present();
        return
      } else {
        if (this.minZadrzVoTOI == 0) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterpoitime"], duration: 3000, position: 'top' });
          toast.present();
          return
        }
      }
    }
    if (this.typeChoosen + '' == '69') {
      if (this.minRoomTemp == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["temperaturechoose"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }
    if (this.typeChoosen + '' == '70') {
      if (this.maxRoomTemp == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["temperaturechoose"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }
    else {

    }

    if (this.typeChoosen + '' == '7') {
      if (this.isNumber(this.nadminSpeed) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["speedpleasenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '54') {
      if (this.isNumber(this.nadminRpm) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["rpmpleasenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '55') {
      if (this.isNumber(this.lowerLimitFuel) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["fuelpleasenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '15') {
      if (this.isNumber(this.otstapuvanjeRuta) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["otstapuvanjeRutapleasenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }


    if (this.typeChoosen + '' == '88') {
      if (this.minBluethootTemp == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["temperaturechoose"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.isNumber(this.minBluethootTemp) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["temepraturenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.alertFor + '' != '1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["chooseoneveh"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this._bval + '' == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["chooseslot"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '106') {
      if (this.maxBluethootTemp == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["temperaturechoose"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.isNumber(this.maxBluethootTemp) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["temepraturenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.alertFor + '' != '1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["chooseoneveh"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this._bval + '' == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["chooseslot"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '90') {
      if (this.maxbluehumidity == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["humiditychoose"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.isNumber(this.maxbluehumidity) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["humiditynumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.alertFor + '' != '1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["chooseoneveh"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this._bval + '' == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["chooseslot"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '91') {
      if (this.minbluehumidity == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["humiditychoose"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.isNumber(this.minbluehumidity) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["humiditynumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.alertFor + '' != '1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["chooseoneveh"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this._bval + '' == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["chooseslot"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '94') {
      if (this._componentNameId == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterServiceComp"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '10') {
      // if (this.isInteger(this.toiZadrzhuvanje) == false) {
      //   let toast = this.toastCtrl.create({ message: this.dic.l["remindmebeforepleasenumbers"], duration: 3000, position: 'top' });
      //   toast.present();
      //   return
      // }
      if (this.isNumber(this.minZadrzVoTOI) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["poistoptimenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '69') {
      if (this.isNumber(this.minRoomTemp) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["temepraturenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '70') {
      if (this.isNumber(this.maxRoomTemp) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["temepraturenumber"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '96') {
      if (this.selectedAZonesIds.length == 0) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterazones"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.alertFor + '' == '-1') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enteralarmfor"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.typeChoosen + '' == '18' || this.typeChoosen + '' == '94') {
      if (this.isNumber(this.remindmeDays) == false && this.remindmeDays != '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["remindmebeforepleasenumbers"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (this.isNumber(this.remindmeKm) == false && this.remindmeKm != '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["remindmebeforepleasenumbers"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    if (this.typeChoosen + '' == '17' || this.typeChoosen + '' == '20' || this.typeChoosen + '' == '79' || this.typeChoosen + '' == '93' || this.typeChoosen + '' == '103') {
      if (this.isNumber(this.remindmeDays) == false) {
        let toast = this.toastCtrl.create({ message: this.dic.l["remindmebeforepleasenumbers"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    // if (this.toemails + '' == '') {
    //   let toast = this.toastCtrl.create({ message: this.dic.l["enteremail"], duration: 3000, position: 'top' });
    //   toast.present();
    //   return
    // }

    if (this.typeChoosen + '' == '17' || this.typeChoosen + '' == '20' || this.typeChoosen + '' == '79' || this.typeChoosen + '' == '93' || this.typeChoosen + '' == '103') {

      if (this.remindmeDays != '') {
        this.remindSave = this.remindmeDays + ' days'
      }
    }
    var _remindmeKm = ''

    if (this.typeChoosen + '' == '18' || this.typeChoosen + '' == '94') {
      if (this.remindmeDays == '' && this.remindmeKm == '') {
        this.remindSave = ''
      }
      if (this.remindmeDays != '') {
        this.remindSave = this.remindmeDays + ' days'
      }
      if (this.remindmeKm != '') {

        _remindmeKm = this.RoundFloat1(this.remindmeKm / this.gn.user.metricvalue) + ''

        this.remindSave = parseInt(_remindmeKm) + ' Km'
      }
      if (this.remindmeKm != '' && this.remindmeDays != '') {
        _remindmeKm = this.RoundFloat1(this.remindmeKm / this.gn.user.metricvalue) + ''

        this.remindSave = this.remindmeDays + ' days' + '; ' + parseInt(_remindmeKm) + ' ' + ' Km'
      }
    }


    if (this.remindSave + '' == '' && (this.typeChoosen + '' == '17' || this.typeChoosen + '' == '18' || this.typeChoosen + '' == '94' || this.typeChoosen + '' == '20' || this.typeChoosen + '' == '79' || this.typeChoosen + '' == '93' || this.typeChoosen + '' == '103')) {
      let toast = this.toastCtrl.create({ message: this.dic.l["remindmemust"], duration: 3000, position: 'top' });
      toast.present();
      return
    }


    var _sett = null;
    if (this.alertFor + '' == '2')
      _sett = this.gn.crypt(this.orgUnit);
    if (this.typeChoosen + '' == '69')
      _sett = this.gn.crypt(this.minRoomTemp);
    if (this.typeChoosen + '' == '70')
      _sett = this.gn.crypt(this.maxRoomTemp);
    if (this.typeChoosen + '' == '15')
      _sett = this.gn.crypt(this.otstapuvanjeRuta);
    if (this.typeChoosen + '' == '88')
      _sett = this.gn.crypt(this.minBluethootTemp);
    if (this.typeChoosen + '' == '106')
      _sett = this.gn.crypt(this.maxBluethootTemp);
    if (this.typeChoosen + '' == '90')
      _sett = this.gn.crypt(this.maxbluehumidity);
    if (this.typeChoosen + '' == '91')
      _sett = this.gn.crypt(this.minbluehumidity);
    if (this.typeChoosen + '' == '94')
      _sett = this.gn.crypt(this._componentNameId);
    if (this.typeChoosen + '' == '55')
      _sett = this.gn.crypt(this.lowerLimitFuel);
    if (this.typeChoosen + '' == '96')
      _sett = this.gn.crypt(this.selectedAZonesIds.join(','));

    var brzina = Math.ceil(this.nadminSpeed / this.gn.user.metricvalue)
    if (this.typeChoosen + '' == '54') {
      brzina = this.nadminRpm
    }
    if (this.toemails + '' != '' && this.emailValidate(this.toemails) != true) {
      let toast = this.toastCtrl.create({ message: this.dic.l["enteremail"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.typeChoosen + '' == '90' || this.typeChoosen + '' == '91' || this.typeChoosen + '' == '88' || this.typeChoosen + '' == '106') {
      if (this._bval == '-1') this._bval = null
    } else {
      this._bval = null
    }


    var dat = {
      alarmtypeid: this.gn.crypt(this.typeChoosen),
      settings: _sett,
      available: this.gn.crypt(this.dostapen),
      emails: this.gn.crypt(this.toemails.replace(/ /g, '')),
      sms: '',
      soundid: this.gn.crypt(this.sound),
      snooze: this.gn.crypt(this.gn.user.Snooze),
      clientid: this.gn.crypt(this.gn.user.ClientId),
      vehicleid: this.gn.crypt(this.oneVehicle),
      speed: this.gn.crypt(brzina),
      speedafter: this.gn.crypt(this._speedafter),
      timeofpoi: this.gn.crypt(this.toiZadrzhuvanje + '' == '-1' ? '-1' : this.minZadrzVoTOI),

      poiid: this.gn.crypt(poiAdd),
      uniqid: this.gn.crypt(Math.floor(Date.now() / 1000)),
      typeofgroup: this.gn.crypt(this.alertFor),
      remindme: this.gn.crypt(this.remindSave),
      smsviaemail: '',
      rid: this.gn.crypt(this.gn.user.RoleId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      orgunit: this.gn.crypt(this.orgUnit),
      uid: this.gn.crypt(this.gn.user.UserId),
      arm: this.gn.crypt(0),
      bleslotnum: this.gn.crypt(this._bval)
      // speedafter: this.gn.crypt(this._speedafter)
    }

    this.gn.tfBtn = true;
    var _that = this
    this.gn._Post('/api/gn/insertalarms', dat, function (_data) {
      // _that.navCtrl.pop()
      // _that.gn.loaderWaiting.dismiss();
      var _cb = _that.navParams.get('cb')
      _cb()
      _that.navCtrl.pop()
      //_that.gn.enableBtn();
      _that.gn.tfBtn = false;
    })


    //mora da ima izbrano opcija za shto treba da se zapishe alertot
    //alertFor != -1 proverka


  }

  presentConfirm() {
    let alert = this.alertCtrl.create({
      title: this.dic.l['choosealert'],
      message: this.dic.l['pleasetypeofalert'],
      buttons: [
        {
          text: this.dic.l['cancel'],
          role: 'cancel',
          handler: () => {
          }
        },
      ]
    });
    alert.present();
  }

  editAlert() {
    var _that = this;
    var count = 0;
    var ids = [];
    var idsStr = '';
    if (this.alert.uniqid != null) {
      //brisheme povekje redici vo baza so toa uniqid
      for (let i = 0; i < this.allAlerts.length; i++) {
        if (this.allAlerts[i].uniqid + '' == this.alert.uniqid + '') {
          count++;
          ids.push(this.allAlerts[i].id);
        }
      }
      idsStr = ids.join(',');
    }
    else {
      idsStr = this.alert.id + '';
    }
    this.gn._Post('/api/gn/deletealarm', { aid: this.gn.crypt(idsStr) }, function (_data) {
      _that.saveAlert();
    })
  }



  isNumber(numb) {
    if (numb + '' != '' && (numb % 0.1 === 0 || numb % 1 === 0)) {
      return true
    }
    else {
      return false
    }
  }


  emailValidate(value) {
    var emailovi = value.split(",");
    var izlez;
    var _ret = false
    emailovi.forEach(function (mejl) {
      var filter = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
      izlez = filter.test(mejl.trim());
      if (!izlez) {
        _ret = true;
        return izlez;
      }
    });
    if (!_ret) {
      return izlez;
    }
  }


  // (parseInt(this.gn.clientsettings.hasbluetoothtemp + '') > 0)

  getAllAlertTypes() {
    var _that = this;
    this.gn._Post('/api/gn/getallalerttypes', { clienttypeid: this.gn.crypt(this.gn.clientsettings.clienttypeid) }, function (_data) {
      var alarmgroup = ''
      for (let i = 0; i < _data.length; i++) {
        _data[i].check = 0;
        _data[i].jump = 1;
        // bluethoottemphigh
        if (_data[i].id == 88 && parseInt(_that.gn.clientsettings.hasbluetoothtemp + '') == 0) {
          _data[i].check = 1
        }
        // bluethoottemplow
        if (_data[i].id == 106 && parseInt(_that.gn.clientsettings.hasbluetoothtemp + '') == 0) {
          _data[i].check = 1
        }
        // bluethoot humidity high
        if (_data[i].id == 90 && parseInt(_that.gn.clientsettings.hasbluetoothtemp + '') == 0) {
          _data[i].check = 1
        }

        // bluethoot humidity low
        if (_data[i].id == 91 && parseInt(_that.gn.clientsettings.hasbluetoothtemp + '') == 0) {
          _data[i].check = 1
        }


        if (_data[i].id == 48 && _that.allowfuel == '0') _data[i].check = 1;  // alarm za dozvoleno gorivo
        if ((_data[i].id == 23 || _data[i].id == 22) && _that.allowedrfid == '0') _data[i].check = 1; // alarm za RFID
        if (_data[i].id == 5 && _that.allowedcapace == '0') _data[i].check = 1; // za dali e dozvoleno kapace za korivo


        if (_data[i].alarmgroup == "3-RoutesCombo" && _that.gn.clientsettings.allowedrouting == '0') _data[i].check = 1;
        if (_data[i].alarmgroup == "4-FleetManagement" && _that.gn.clientsettings.allowedfm == '0') _data[i].check = 1;
        if (_data[i].alarmgroup == "6-MotoAlarms" && _that.gn.clientsettings.clienttypeid != 6) _data[i].check = 1;
        if (_data[i].alarmgroup == "8-AssetAlerts" && _that.gn.clientsettings.clienttypeid != 7) _data[i].jump = 0;
        if (_data[i].alarmgroup == "7-SecurityAlerts" && _that.gn.clientsettings.clienttypeid != 8 && _that.gn.clientsettings.clienttypeid != 18) _data[i].jump = 0;
        if (_data[i].alarmgroup == "9-OBDAlerts" && _that.gn.clientsettings.clienttypeid != 9) _data[i].jump = 0;
        if (_data[i].alarmgroup == "10-PersonalAlerts" && _that.gn.clientsettings.clienttypeid != 3) _data[i].jump = 0;

        //tow (A37) da go ima za site so clienttypeid=1 (distribucija) i clienttypeid=6 (motorcycle)
        //if (_data[i].id == 37 && (_that.gn.clientsettings.clienttypeid == 1 || _that.gn.clientsettings.clienttypeid == 6)) _data[i].check = 0;

        // [END]. proverki --------------------------------------------------------------------------------------
        if (_data[i].jump == 1) {
          if (_data[i].alarmgroup == alarmgroup) {
            // prikazi gi site od ist alarmgroup
            // ?>
            // _data[i].header = false;
            // _data[i].nameHeader = '';
            // _that.alertTypes.push(_data[i])
            var disb = false;
            if (_data[i].check == 1) {
              disb = true;
            }
            _that.alertTypes.push({ at: _data[i], header: false, disabled: disb, nameHeader: '' })
          } else {
            // promeni go

            alarmgroup = _data[i].alarmgroup;
            // if(_data[i].alarmgroup == ''){
            // alarmgroup = '*-settings';
            // }
            var alarmgroupShow = alarmgroup.split('-')

            _that.alertTypes.push({ at: _data[i], header: true, disabled: false, nameHeader: alarmgroupShow[1] })


            var disb = false;
            if (_data[i].check == 1) {
              disb = true;
            }
            _that.alertTypes.push({ at: _data[i], header: false, disabled: disb, nameHeader: '' })
            // prikazi ja taa grupa kako disabled vo option
            // ?>
            // <option disabled="disabled">----------------------<?php dic("Settings." . alarmgroupShow[1]) ?>----------------------</option>
            // <option value="<?php echo $alarmRow['id'] ?>" <?php if($alarmRow["check"]==1) echo "disabled='disabled'" ?>><?php dic($alarmRow['name']) ?></option>
            // <?php
          }
        }
      }
      _that.countloading++
      if (_that.countloading == 3) {
        _that.loadingData = true
      }
    })
  }

  choosetype(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(AlerttypesPage, {
      alerttypes: _that.alertTypes, id: _that.typeChoosen,
      callback: function (id, name, nameW) {
        _that.typeChoosen = id
        _that.typeChoosenName = name
      }
    }, { cssClass: 'alerttypes-popover' });
    popover.present({
      ev: _ev
    });
  }


  chooseType() {
    // console.log(this.typeChoosen)
  }
  chooseTOIzadrzh() {
    // console.log(this.toiZadrzhuvanje)
  }

  choosePOIvlez() {
    // console.log(this.poiVlez)
  }
  choosePOIizlez() {
    // console.log(this.poiIzlez)
  }

  chooseAlertFor() {
    // console.log(this.alertFor)
    if (this.alertFor + '' == '1') {
      this.oneVehicle = this.gn.Vehicles[0].vehicleid
      this.orgUnit = '-1';
    }
    else if (this.alertFor + '' == '2') {
      this.orgUnit = this.gn.Organisations[0].id + ''
      this.oneVehicle = '';
    }
    else {
      this.orgUnit = '-1';
      this.oneVehicle = '';
    }
  }
  chooseOneVehicle() {
    // console.log(this.oneVehicle)
  }
  chooseOrgUnit() {
    // console.log(this.orgUnit)
  }

  getPOItype1() {
    var _that = this;
    this.gn._Post('/api/gn/getpoitype1', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.poitype1 = _data;
      _that.countloading++
      if (_that.countloading == 3) {
        _that.loadingData = true
      }
    })
  }

  getPOItype23() {
    var _that = this;
    this.gn._Post('/api/gn/getpoitype23', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.poitype23 = _data;
      _that.countloading++

      if (_that.countloading == 3) {
        _that.loadingData = true
      }

      if (_that.typeChoosen + '' == '96') {
        if (_that._az != '') {
          var tmp = []
          for (var i = 0; i < _that._az.split(',').length; i++) {
            _that.selectedAZonesIds.push(parseInt((_that._az.split(','))[i]))
            for (var j = 0; j < _that.poitype23.length; j++) {
              //console.log(_that.poitype23[j], _that._az.split(',')[i])
              if (_that.poitype23[j].id + '' == _that._az.split(',')[i] + '') {
                tmp.push(_that.poitype23[j].name)
              }
            }
          }
          _that.selectedAZones = tmp.join(', ')
        }
      }

      // console.log(_that.poitype23)
    })
  }

  getSettingsForClientUser() {
    // console.log("VLEGOV VO POVIKUVANJE NA SETTINGS ")
    var _that = this;
    this.gn._Post('/api/gn/getsettingsclientuseralerts', {
      rid: this.gn.crypt(this.gn.user.RoleId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      uid: this.gn.crypt(this.gn.user.UserId)
    }, function (_data) {
      _that.allowfuel = _data.allowfuel
      _that.allowedrfid = _data.allowedrfid
      _that.allowedcapace = _data.allowedcapace
      _that.getAllAlertTypes();
      _that.getPOItype1();
      _that.getPOItype23();
      _that.getComponents();
    })
  }

  getComponents() {
    var _that = this;
    this.gn._Post('/api/gn/getFmcomponents', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.components = _data;
      //debugger
    })
  }
  availableFor(_type: any) {
    this.dostapen = _type;
  }

  RoundFloat1(_txt) {
    return parseFloat(_txt + '').toFixed(0);
  }


  openVehiclePopup(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-routing', selected: [], callback: function (_text, _ids) {
        _that.selectedVehicleName = _text;
        _that.selectedVehicleIds = parseInt(_ids) + '';
        _that.oneVehicle = _ids;

        _that.gn._Post('/api/gn/getallbleslots', { vid: _that.gn.crypt(_that.oneVehicle) }, function (_data) {
          _that._bleslots = _data
          if (_that.alertid == -1) {
            if (_that._bleslots.length > 0)
              _that._bval = '-1'
          } else {
            _that._bval = _that.alert.bleslotnum
          }
        })
      }
    });
    popover.present({
      ev: _ev
    });
  }

  selectAZones(_ev) {
    var _that = this
    console.log(_that.poitype23)
    let popover = _that.popoverCtrl.create(PopupPage, {
      type: 'alert-allowedzones', selected: '', arrayData: _that.poitype23, selAZonesId: _that.selectedAZonesIds, callback: function (_text, _ids) {
        var tmp = []
        _that.selectedAZonesIds = []
        for (let ii = 0; ii < _ids.length; ii++) {
          if (_ids[ii].ch) {
            for (var i = 0; i < _that.poitype23.length; i++) {
              if (_that.poitype23[i].id + '' == _ids[ii].id + '') {
                tmp.push(_that.poitype23[i].name)
                _that.selectedAZonesIds.push(_ids[ii].id)
                _that.idxAZones += ii + ';'
              }
            }

          }
        }
        _that.selectedAZones = tmp.join(', ')
      }
    }, { cssClass: 'popover-content-processes' });
    popover.present({ ev: _ev });
  }
}







// WEBPACK FOOTER //
// ./src/pages/settings/alerts/alertsadd.ts